import api from "../services/api"; // adjust path if needed

export const fetchDiscountRules = () => api.get("/admin/discount-rules");
export const createDiscountRule = (data) =>
  api.post("/admin/discount-rules", data);
export const updateDiscountRule = (id, data) =>
  api.put(`/admin/discount-rules/${id}`, data);
export const deleteDiscountRule = (id) =>
  api.delete(`/admin/discount-rules/${id}`);

export const fetchActiveDiscountRules = () =>
  api.get("/admin/discount-rules/active");

export const fetchDiscountRulesPage = ({
  cursor = null,
  limit = 25,
  q = "",
  status = "",
  type = "",
  enabled = "",
} = {}) =>
  api.get("/admin/discount-rules", {
    params: {
      paginated: true,
      limit,
      ...(q ? { q } : {}),
      ...(status ? { status } : {}),
      ...(type ? { type } : {}),
      ...(enabled ? { enabled } : {}),
      ...(cursor ? { cursor } : {}),
    },
  });
